import { PermissionType } from "../models/enum/permission.enum";

export const PAGE_PERMISSIONS = [
    { page: 'analysis-request', permissions: [PermissionType.portalAdmin, PermissionType.portalUser, PermissionType.customerAdmin, PermissionType.customerUser] },
    { page: 'customers-panel', permissions: [PermissionType.portalAdmin, PermissionType.customerAdmin] },
    { page: 'users-panel', permissions: [PermissionType.portalAdmin, PermissionType.customerAdmin] }
];
